export default "__VITE_ASSET__CXGYmq6G__"